import React, { useState } from "react";
import {
  TQuestion,
  TQuizAttempt,
} from "../../../../entities/Moodle/model/MoodleTypes";
import { Button, Divider, Input } from "antd";
import { moodleApi } from "../../../../entities/Moodle";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
const Question = ({
  question,
  setQuestions,
  attempt,
}: {
  setQuestions: any;
  question: TQuestion;
  attempt: TQuizAttempt | null;
}) => {
  const [answer, setAnswer] = useState("");
  const onClick = () => {
    console.log("question.sequencecheck", question.sequencecheck);
    if (answer.length > 0)
      moodleApi
        .checkQuestionAnswer({
          answer: Number(answer),
          attempt_id: attempt?.id,
          slots: question.slot,
          sequencecheck: question.sequencecheck,
          question_number: question.questionnumber
        })
        .then((response) => {
          setQuestions(response.data.questions);
          console.log("ANSWER CHECK", response.data.questions);
        })
        .catch((e) => { });
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginRight: 10 }}>Вопрос</div>
        <div style={{ fontWeight: 600 }}>{question.question}</div>
        <Input
          status={question.status == "Incorrect" ? "error" : undefined}
          onChange={(e) => setAnswer(e.target.value)}
          style={{ width: 55, marginLeft: 20 }}
        />
        {question.status == "Incorrect" && (
          <CloseOutlined style={{ color: "red", marginLeft: 5 }} />
        )}
        {question.status == "Correct" && (
          <CheckOutlined style={{ color: "green", marginLeft: 5 }} />
        )}
        <Button onClick={onClick} style={{ marginLeft: 15 }}>
          Ответить
        </Button>
      </div>
      <Divider style={{ marginTop: 5 }} />
    </div>
  );
};

export default Question;
